import dayjs from "dayjs"

export const endDateTimeMinDate = dayjs().startOf("day").set("hour", 1).toDate()
export const endDateTimeMaxDate = dayjs().startOf("day").set("hour", 23).set("minute", 59).toDate()

export const useDateTimeCalendarProps = () => {
  const validateStartDateTime = (
    newStartDateTime: Date,
    endDateTime: Date | null,
    set: (val: Date) => void,
    minDurationInMinutes?: number,
  ) => {
    const newStartDays = dayjs(newStartDateTime).set("second", 0).set("millisecond", 0)

    if (!newStartDays.isBefore(dayjs(endDateTime))) {
      if (newStartDays.hour() === 23) {
        set(newStartDays.set("minute", 59).toDate())
      } else {
        if (typeof minDurationInMinutes !== "undefined") set(newStartDays.add(minDurationInMinutes, "minute").toDate())
        else {
          set(newStartDays.add(1, "hour").toDate())
        }
      }
    }
  }

  const validateEndDateTime = (
    newEndDateTime: Date,
    startDateTime: Date | null,
    set: (val: Date | null) => void,
    avoidNull: boolean = false,
    minDurationInMinutes?: number,
  ) => {
    const endDateTimeDaysjs = dayjs(newEndDateTime).set("second", 0).set("millisecond", 0)

    if (
      !endDateTimeDaysjs.isAfter(dayjs(startDateTime)) ||
      endDateTimeDaysjs.format("HH:mm:ss ZZ") > dayjs(endDateTimeMaxDate).format("HH:mm:ss ZZ") ||
      endDateTimeDaysjs.format("HH:mm:ss ZZ") < dayjs(endDateTimeMinDate).format("HH:mm:ss ZZ")
    ) {
      if (avoidNull) {
        if (endDateTimeDaysjs.hour() === 0) {
          set(endDateTimeDaysjs.set("minute", 0).toDate())
        } else {
          if (typeof minDurationInMinutes !== "undefined")
            set(endDateTimeDaysjs.add(-minDurationInMinutes, "minute").toDate())
          else set(endDateTimeDaysjs.add(-1, "hour").toDate())
        }
      } else {
        set(null)
      }
    }
  }

  return {
    validateStartDateTime,
    validateEndDateTime,
  }
}
